import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/utills/axios'
import router from '@/router'
import {
  Message
} from 'element-ui';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: ''
  },
  mutations: {
    set_token(state) {
      state.token = sessionStorage.getItem('token')
    }
  },
  actions: {
    // 登出
    logOut() {
      Message.closeAll();
      axios.post("/config/user/logout", {}).then(res => {
        router.push("/login");
        sessionStorage.clear();
      });
    }
  },
  modules: {}
})